import CallService from "../projects/cc/services/CallService";
import { useDialogStore } from "~/projects/cc/stores/dialogStore";
import {
  getCleanedCustomerNumber,
  getCustomerUriInfo,
} from "~/projects/cc/utils/callCenterHelper";
import { CallEventType } from "~/types/callEventType";

export default class IFrameIntegration {
  private dialogStore: ReturnType<typeof useDialogStore> | null = null;
  private callService: CallService | null = null;

  public init(callService: CallService) {
    const { $listen } = useNuxtApp();

    this.onParentMsg = this.onParentMsg.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onProgress = this.onProgress.bind(this);

    this.dialogStore = useDialogStore();
    this.callService = callService;

    window.addEventListener("message", this.onParentMsg);
    $listen("progress", this.onProgress);
    $listen("completed", this.onComplete);
  }

  private onParentMsg(e: MessageEvent) {
    if (e.source === window) return;
    // if (e.origin !== 'http://localhost:9000') return;
    const { fn, args } = e.data;

    console.log("iframe msg rcv", fn, args);

    if (fn === "call") {
      this.callService?.makeCall(args[0]);
    }
    if (fn === "endCall") {
      this.callService?.endCall();
      this.dialogStore?.setIncomingModalVisibility(false);
    }
    if (fn === "acceptCall") {
      
      this.callService?.acceptCall();
      this.dialogStore?.setOngoingModalVisibility(true);
      this.dialogStore?.setIncomingModalVisibility(false);
    }
  }

  private onProgress(evt: CallEventType) {
    if (evt.direction === "incoming") {
      const { phoneNumber } = getCustomerUriInfo(
        this.callService?.getCallerUri() || "",
      );
      const number = getCleanedCustomerNumber(phoneNumber);
      window.parent.postMessage({ fn: "callIncoming", args: [number] }, "*");
    }
  }

  private onComplete() {
    window.parent.postMessage({ fn: "callEnded" }, "*");
  }

  public destroy() {
    const { $unListen } = useNuxtApp();
    window.removeEventListener("message", this.onParentMsg);
    $unListen("progress", this.onProgress);
    $unListen("completed", this.onComplete);
  }
}
